import script from "./DeepRoom.vue?vue&type=script&setup=true&lang=js"
export * from "./DeepRoom.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./DeepRoom.vue?vue&type=style&index=0&id=f1016c72&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__